<template>
    <div class="rd-shell">
        <navigation-top></navigation-top>
        <main class="rd-main">
            <router-view></router-view>
        </main>
    </div>
</template>

<script>
import NavigationTop from "@/views/layout/NavigationTop";

export default {
    name: "Home",
    components: {
        NavigationTop
    }
}
</script>

<style scoped>
.rd-shell {
    min-height: 100vh;
    display: flex;
    flex-direction: column;
}

.rd-main {
    flex: 1;
    width: 100%;
    max-width: 1180px;
    margin: 0 auto;
    padding: 2.25rem 1.5rem 3rem;
}

@media (max-width: 600px) {
    .rd-main { padding: 1.5rem 1rem 2.5rem; }
}
</style>
